import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { projectsUrl } from '../../Testimonials/util';
import cx from 'classnames';

export interface CollectResponsesButtonProps {
  className?: string;
  variant?: ButtonVariant;
  icon?: React.ReactNode;
  text?: string;
}

export default function CollectResponsesButton({
  className,
  variant = ButtonVariant.Info,
  icon,
  text = 'Collect responses',
}: CollectResponsesButtonProps) {
  const buttonContent = (
    <span className='flex items-center justify-center truncate gap-3'>
      {icon}
      {text}
    </span>
  );

  return (
    <a href={projectsUrl}>
      <Button className={cx(className, 'h-10')} variant={variant}>
        {buttonContent}
      </Button>
    </a>
  );
}
